import iconId from './svg/icon_id.svg'

interface IdCardIconProps {
  className?: string
}

export function IdCardIcon({ className = 'w-24 h-24' }: IdCardIconProps) {
  return <img src={iconId} alt='ID Card' className={className} />
}
